<template>
  <utility-detail-link ref="utilityDetailLink" :detailLayout="detailLayout" :utilityData="utilityData"
                       :utilKey="utilKey" :userKey="userKey" :utilTopCategory="utilityTopCategoryList" :utilBottomCategory="utilityBottomCategoryList"
                       :defaultApiParamsSet="defaultApiParamsSet"></utility-detail-link>

</template>

<script>
import util from "../../mixins/util";
import alertMixins from "../../mixins/alertMixins";
import UtilityDetailLink from "@/components/utility/UtilityDetailLink.vue";
import utilityUtil from "@/components/utility/utilityUtil";
import EventBus from "@/utils/event-bus";

export default {
  name: "UtilityDetailComponent",
  mixins: [utilityUtil, alertMixins],
  components: {UtilityDetailLink},
  inject: [],
  provide() {
    return {}
  },
  props: {
    utilityType: {
      default: () => {
      }
    },
    utilKey: {default: 0},
    userKey: {default: 0},
    defaultApiParamsSet: {}
  },
  data() {
    return {
      detailLayout: '',
      getFunc: '',
      utilityData: {},
      keyName: '',

      utilityTopCategoryList: [],
      utilityBottomCategoryList: [],
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.initData();
  },
  mounted() {
    EventBus.$on('utilDelete', this.runDeleteConfirm)
    this.getUtilTopCategory();
    this.getUtilBottomCategory();
  },
  beforeUnmount() {
    EventBus.$off('utilDelete')
  },
  unmounted() {
  },
  computed: {},
  methods: {
    initData() {
      let config = this.returnUtilityConfig(this.utilityType);
      this.detailLayout = config.detailLayout;
      this.getFunc = config.getFunc;
      this.detailApiParamSet = config.detailApiParamSet;
      this.keyName = config.keyName;
      this.getUtilityDetail()

    },
    getUtilityDetail() {
      let params = Object.assign({}, this.detailApiParamSet, this.defaultApiParamsSet);
      params[this.keyName] = this.userKey

      try {
        this.$api.$utility[this.getFunc](params).then(res => res.Data.Result).then(res => {
          if (!util.isEmpty(res.List)) {
            this.utilityData = res.List[0];
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    getUtilTopCategory() {
      let params = {
        parent : [0],
      };

      try {
        this.$api.$utility.getUtilityCategory(params).then(res => res.Data.Result).then(res => {
          if (!util.isEmpty(res.List)) {
            this.utilityTopCategoryList = res.List;
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    getUtilBottomCategory() {
      let params = {
        child : 1,
      };

      try {
        this.$api.$utility.getUtilityCategory(params).then(res => res.Data.Result).then(res => {
          if (!util.isEmpty(res.List)) {
            this.utilityBottomCategoryList = res.List;
          }
        })
      } catch (e) {
        console.log(e)
      }
    },

  },
  watch: {},
};
</script>

<style scoped>

</style>
